module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5Ljc3NyA0SDM0Ljk5MDVMMjMuNjAwNSAxNy41NTQ5TDM3IDM2SDI2LjUwODNMMTguMjkwOCAyNC44MTMxTDguODg4MDggMzZIMy42NzEzOUwxNS44NTQyIDIxLjUwMTVMMyA0SDEzLjc1ODFMMjEuMTg2IDE0LjIyNTJMMjkuNzc3IDRaTTI3Ljk0NzIgMzIuNzUwOEgzMC44MzYxTDEyLjE4ODMgNy4wNzg1OEg5LjA4ODIxTDI3Ljk0NzIgMzIuNzUwOFoiIGZpbGw9IiMyMTA0MkUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg/blog_detail_x.svg
// module id = RY9X
// module chunks = 8